import { render } from "./PsNavBar.vue?vue&type=template&id=b2123c26"
import script from "./PsNavBar.vue?vue&type=script&lang=js"
export * from "./PsNavBar.vue?vue&type=script&lang=js"

import exportComponent from "G:\\wamp\\www\\vahanwale\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__